export function resolveHasNextPage(
  offset: number,
  total: number,
  list: Array<any> | null
) {
  if (!list) {
    return false
  }

  return offset + list.length < total
}

export function resolvePrevPage(offset: number) {
  return offset > 0
}

export function computeOffset(page: number, pageSize: number) {
  return (page - 1) * pageSize
}
